import MileageAddRequest from "../../api/raily/mileage/add/mileage-add.request";
import MileageAddressListRequest from "../../api/raily/mileage/address/list/mileage-address-list.request";
import MileageAddressListResponse from "../../api/raily/mileage/address/list/mileage-address-list.response";
import MileageDetailsRequest from "../../api/raily/mileage/details/mileage-details.request";
import MileageDetailsResponse from "../../api/raily/mileage/details/mileage-details.response";
import MileageDownloadAllCSVRequest from "../../api/raily/mileage/download-all-csv/mileage-download-all-csv.request";
import MileageDictionaryAddRequest from "../../api/raily/mileage/dictionary/add/mileage-dictionary-add.request";
import MileageDictionaryListRequest from "../../api/raily/mileage/dictionary/list/mileage-dictionary-list.request";
import MileageDictionaryUpdateRequest from "../../api/raily/mileage/dictionary/update/mileage-dictionary-update.request";
import MileageDownloadRequest from "../../api/raily/mileage/download/mileage-download.request";
import MileageListRequest from "../../api/raily/mileage/list/mileage-list.request";
import MileageListResponse from "../../api/raily/mileage/list/mileage-list.response";
import mileageApiService from "../../api/raily/mileage/mileage-api.service";
import MileageUpdateRequest from "../../api/raily/mileage/update/mileage-update-request";
import {
  MileageUpdateNotAcceptableResponse,
  MileageUpdateNotAcceptableResponseErrorType,
} from "../../api/raily/mileage/update/mileage-update-response";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import fileDownloadService from "../../utils/file-download/file-download.service";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import SearchRoadRoutingRequest from "../../utils/search-road-route/search-road-routing.request";
import SearchRoadRoutingResponse from "../../utils/search-road-route/search-road-routing.response";
import searchRoadRoutingService from "../../utils/search-road-route/search-road-routing.service";
import MileageAddError from "./add/mileage-add-error";
import MileageAddParams from "./add/mileage-add-params";
import mileageAddParamsFactory from "./add/mileage-add-params.factory";
import MileageAddressListItem from "./address/list/mileage-address-list";
import MileageAddressListError from "./address/list/mileage-address-list-error";
import MileageAddressListParams from "./address/list/mileage-address-list-params";
import mileageAddressListParamsFactory from "./address/list/mileage-address-list-params.factory";
import mileageAddressListFactory from "./address/list/mileage-address-list.factory";
import MileageDetails from "./details/mileage-details";
import MileageDetailsParams from "./details/mileage-details-params";
import mileageDetailsParamsFactory from "./details/mileage-details-params.factory";
import mileageDetailsFactory from "./details/mileage-details.factory";
import MileageDownloadAllCSV from "./download-all-csv/mileage-download-all-csv";
import MileageDownloadAllCSVError from "./download-all-csv/mileage-download-all-csv-error";
import MileageDownloadAllCSVParams from "./download-all-csv/mileage-download-all-csv-params";
import mileageDownloadAllCSVRequestFactory from "./download-all-csv/mileage-download-all-csv-request.factory";
import mileageDownloadAllCSVFactory from "./download-all-csv/mileage-download-all-csv.factory";
import MileageDictionaryAddError from "./dictionary/add/mileage-dictionary-add-error";
import MileageDictionaryAddParams from "./dictionary/add/mileage-dictionary-add-params";
import mileageDictionaryAddParamsFactory from "./dictionary/add/mileage-dictionary-add-params.factory";
import MileageDictionaryDetails from "./dictionary/details/mileage-dictionary-details";
import MileageDictionaryDetailsError from "./dictionary/details/mileage-dictionary-details-error";
import MileageDictionaryDetailsParams from "./dictionary/details/mileage-dictionary-details-params";
import mileageDictionaryDetailsParamsFactory from "./dictionary/details/mileage-dictionary-details-params.factory";
import mileageDictionaryDetailsFactory from "./dictionary/details/mileage-dictionary-details.factory";
import MileageDictionaryList from "./dictionary/list/mileage-dictionary-list";
import MileageDictionaryListError from "./dictionary/list/mileage-dictionary-list-error";
import MileageDictionaryListParams from "./dictionary/list/mileage-dictionary-list-params";
import MileageDictionaryListParamsFactory from "./dictionary/list/mileage-dictionary-list-params.factory";
import mileageDictionaryListFactory from "./dictionary/list/mileage-dictionary-list.factory";
import MileageDictionaryUpdateError from "./dictionary/update/mileage-dictionary-update-error";
import MileageDictionaryUpdateParams from "./dictionary/update/mileage-dictionary-update-params";
import mileageDictionaryUpdateParamsFactory from "./dictionary/update/mileage-dictionary-update-params.factory";
import MileageDownloadError from "./download/mileage-download-error";
import MileageDownloadParams from "./download/mileage-download-params";
import mileageDownloadParamsFactory from "./download/mileage-download-params.factory";
import MileageList from "./list/mileage-list";
import MileageListParams from "./list/mileage-list-params";
import mileageListParamsFactory from "./list/mileage-list-params.factory";
import mileageListFactory from "./list/mileage-list.factory";
import MileageRoadRouteItem from "./road-route/mileage-road-route-item";
import MileageRoadRouteParams from "./road-route/mileage-road-route-params";
import mileageRoadRouteParamsFactory from "./road-route/mileage-road-route-params.factory";
import mileageRoadRouteFactory from "./road-route/mileage-road-route.factory";
import MileageSettingsAddError from "./settings/add/mileage-settings-add-error";
import MileageSettingsAddParams from "./settings/add/mileage-settings-add-params";
import mileageSettingsAddParamsFactory from "./settings/add/mileage-settings-add-params.factory";
import MileageSettingsDetails from "./settings/details/mileage-settings-details";
import MileageSettingsDetailsError from "./settings/details/mileage-settings-details-error";
import MileageSettingsDetailsParams from "./settings/details/mileage-settings-details-params";
import mileageSettingsDetailsParamsFactory from "./settings/details/mileage-settings-details-params.factory";
import mileageSettingsDetailsFactory from "./settings/details/mileage-settings-details.factory";
import MileageSettingsUpdateError from "./settings/update/mileage-settings-update-error";
import MileageSettingsUpdateParams from "./settings/update/mileage-settings-update-params";
import mileageSettingsUpdateParamsFactory from "./settings/update/mileage-settings-update-params.factory";
import MileageUpdateError from "./update/mileage-update-error";
import mileageUpdateErrorFactory from "./update/mileage-update-error.factory";
import MileageUpdateParams from "./update/mileage-update-params";
import mileageUpdateParamsFactory from "./update/mileage-update-params.factory";

const getList = async (
  params: MileageListParams,
  abortSignal: AbortSignal,
): Promise<MileageList> => {
  const request: MileageListRequest = mileageListParamsFactory.create(params);

  try {
    const response: MileageListResponse = await mileageApiService().getList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const mileageList: MileageList = mileageListFactory.create(response);

    return mileageList;
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const add = async (
  params: MileageAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: MileageAddRequest = mileageAddParamsFactory.create(params);

  try {
    const response = await mileageApiService().add(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | MileageAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const download = async (
  params: MileageDownloadParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: MileageDownloadRequest =
    mileageDownloadParamsFactory.create(params);

  try {
    const response = await mileageApiService().download(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    fileDownloadService.downloadFromBlob(
      response.data.data,
      response.data.filename,
    );
  } catch (_error) {
    const error = _error as HttpError | MileageDownloadError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const downloadAllCSV = async (
  params: MileageDownloadAllCSVParams,
  abortSignal: AbortSignal,
): Promise<MileageDownloadAllCSV> => {
  const request: MileageDownloadAllCSVRequest =
    mileageDownloadAllCSVRequestFactory.create(params);

  try {
    const response = await mileageApiService().downloadAllCSV(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return mileageDownloadAllCSVFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | MileageDownloadAllCSVError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getRoute = async (
  params: MileageRoadRouteParams,
): Promise<MileageRoadRouteItem> => {
  const request: SearchRoadRoutingRequest =
    mileageRoadRouteParamsFactory.create(params);

  try {
    const response: SearchRoadRoutingResponse =
      await searchRoadRoutingService.search(request);

    const RoadRouteItems: MileageRoadRouteItem =
      mileageRoadRouteFactory.create(response);

    return RoadRouteItems;
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const createMileageUpdateErrorsNotAcceptableResponse = (
  response: MileageUpdateNotAcceptableResponse,
): MileageUpdateError => {
  switch (response.data.errorType) {
    case MileageUpdateNotAcceptableResponseErrorType.MILEAGE_HAS_DELEGATION:
      return mileageUpdateErrorFactory.createMileageHasDelegationError();
    case MileageUpdateNotAcceptableResponseErrorType.NO_VALID_MILEAGE_CONTRACT_FOUND:
      return mileageUpdateErrorFactory.createNoValidMileageContractFoundError();
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const update = async (
  params: MileageUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: MileageUpdateRequest =
    mileageUpdateParamsFactory.create(params);

  try {
    const response = await mileageApiService().updateMileage(
      request,
      abortSignal,
    );

    if (response.status === 406) {
      throw createMileageUpdateErrorsNotAcceptableResponse(
        response as unknown as MileageUpdateNotAcceptableResponse,
      );
    }

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | MileageUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDetails = async (
  params: MileageDetailsParams,
  abortSignal: AbortSignal,
): Promise<MileageDetails> => {
  const request: MileageDetailsRequest =
    mileageDetailsParamsFactory.create(params);

  try {
    const response: MileageDetailsResponse =
      await mileageApiService().getDetails(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const mileageDetails: MileageDetails =
      mileageDetailsFactory.create(response);

    return mileageDetails;
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const addSettings = async (
  params: MileageSettingsAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = mileageSettingsAddParamsFactory.create(params);

  try {
    const response = await mileageApiService().addSettings(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | MileageSettingsAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getSettingsDetails = async (
  params: MileageSettingsDetailsParams,
  abortSignal: AbortSignal,
): Promise<MileageSettingsDetails | null> => {
  const request = mileageSettingsDetailsParamsFactory.create(params);

  try {
    const response = await mileageApiService().getSettingsDetails(
      request,
      abortSignal,
    );

    if (response.status === 404) {
      return null;
    }

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const details = mileageSettingsDetailsFactory.create(response);
    return details;
  } catch (_error) {
    const error = _error as HttpError | MileageSettingsDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateSettings = async (
  params: MileageSettingsUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = mileageSettingsUpdateParamsFactory.create(params);

  try {
    const response = await mileageApiService().updateSettings(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | MileageSettingsUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getAddressList = async (
  params: MileageAddressListParams,
  abortSignal: AbortSignal,
): Promise<MileageAddressListItem[]> => {
  const request: MileageAddressListRequest =
    mileageAddressListParamsFactory.create(params);

  try {
    const response: MileageAddressListResponse =
      await mileageApiService().getAddressList(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const addressListItems: MileageAddressListItem[] =
      mileageAddressListFactory.create(response);

    return addressListItems;
  } catch (_error) {
    const error = _error as HttpError | MileageAddressListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDictionaryList = async (
  loadParams: MileageDictionaryListParams,
  abortSignal: AbortSignal,
): Promise<MileageDictionaryList> => {
  const request: MileageDictionaryListRequest =
    MileageDictionaryListParamsFactory.create(loadParams);

  try {
    const response = await mileageApiService().dictionaryList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return mileageDictionaryListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | MileageDictionaryListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addDictionary = async (
  params: MileageDictionaryAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: MileageDictionaryAddRequest =
    mileageDictionaryAddParamsFactory.create(params);

  try {
    const response = await mileageApiService().addDictionary(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | MileageDictionaryAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateDictionary = async (
  params: MileageDictionaryUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: MileageDictionaryUpdateRequest =
    mileageDictionaryUpdateParamsFactory.create(params);

  try {
    const response = await mileageApiService().updateDictionary(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | MileageDictionaryUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDictionaryDetails = async (
  params: MileageDictionaryDetailsParams,
  abortSignal: AbortSignal,
): Promise<MileageDictionaryDetails> => {
  const request = mileageDictionaryDetailsParamsFactory.create(params);

  try {
    const response = await mileageApiService().getDictionaryDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return mileageDictionaryDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | MileageDictionaryDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const mileageService = {
  getList,
  add,
  download,
  getRoute,
  getDetails,
  update,
  downloadAllCSV,
  addSettings,
  getSettingsDetails,
  updateSettings,
  getAddressList,
  addDictionary,
  updateDictionary,
  getDictionaryDetails,
  getDictionaryList,
};

export default mileageService;
